import MeasurementReport from "./MeasurementReport.js";
import Polyline from "./Polyline.js";
import Polygon from "./Polygon.js";
import Point from "./Point.js";
import Circle from "./Circle.js";

const DICOMMicroscopyViewer = {
    Polyline,
    Polygon,
    Point,
    Circle,
    MeasurementReport
};

export default DICOMMicroscopyViewer;
